import React from 'react';
import { classes } from '../../lib';
import Styles from './Carousel.module.less';

type CarouselImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
    key: React.Key;
    carouselClassName?: string;
};

const CarouselImage = ({
    key,
    carouselClassName,
    ...props
}: CarouselImageProps): JSX.Element => (
    <div key={key} className={classes(Styles.picture, carouselClassName)}>
        <img {...props} />
    </div>
);

export { CarouselImage };
export type { CarouselImageProps };
